const env = {
    OTC_SERVICE_URL: process.env.REACT_APP_OTC_SERVICE_URL || "https://uat-api-wallet.aiavatar.fun",
    MARKET_SERVICE_URL: process.env.REACT_APP_MARKET_SERVICE_URL || "https://uat-apife.aiavatar.fun",
    API_KEY: process.env.REACT_APP_API_KEY || "AIzaSyCa5jsp8Og6XMGoptlC3QKSqsfMgmURJFU",
    PACKAGE_ANDROID: process.env.REACT_APP_PACKAGE_ANDROID || "com.wallet.walkthedog.uat",
    PACKAGE_IOS: process.env.REACT_APP_PACKAGE_IOS || "com.businesssw.walkDog",
    DOMAIN_URI_PREFIX: process.env.REACT_APP_DOMAIN_URI_PREFIX || "https://suzuwalkuat.page.link",
    FB_APP_ID: process.env.REACT_APP_FB_APP_ID,
    APPLE_CLIENT_ID: process.env.REACT_APP_APPLE_CLIENT_ID,
    GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    INSTAGRAM_APP_ID: process.env.REACT_APP_INSTAGRAM_APP_ID,
    APPLE_CALL_BACK_URL: process.env.REACT_APP_APPLE_CALL_BACK_URL,
    MARKETPLACE_URL: process.env.REACT_APP_MARKETPLACE_URL,
    SSO_API_URL: process.env.REACT_APP_SSO_BASE_API_URL,
    AUTH_API_URL: process.env.REACT_APP_AUTH_BASE_URL,
    IPFS_PROJECT_ID: process.env.REACT_APP_IPFS_PROJECT_ID,
    IPFS_PROJECT_SECRET: process.env.REACT_APP_IPFS_PROJECT_SECRET,
    AUTH_COOKIE_KEY: process.env.REACT_APP_AUTH_COOKIE_KEY,
    RECAPTHA_SITE_KEY: process.env.REACT_APP_RECAPTHA_SITE_KEY,
    RECAPTHA_SECRET_KEY: process.env.RECAPTHA_SECRET_KEY,
    FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    SCHEMA_APP: process.env.REACT_APP_SCHEMA_APP || 'suzuwalk',
    MLM_REGISTRATION_URL: process.env.REACT_APP_MLM_REGISTRATION_URL,
    MLM_LOGIN_URL: process.env.REACT_APP_MLM_LOGIN_URL
}

export default env;